import { render } from "./Reflections.vue?vue&type=template&id=365c53e2"
import script from "./Reflections.vue?vue&type=script&lang=js"
export * from "./Reflections.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__